customElements.define('formula-quiz', class FormulaQuiz extends HTMLElement {
  static get observedAttributes() {
    return ["data-state"];
  }
  constructor() {
    super();  

    this.open = document.querySelectorAll("[data-open-quiz]")
    this.close = this.querySelector(".quiz__close")
    this.headlines = this.querySelectorAll(".quiz__headline")
    this.quizCards = this.querySelectorAll(".form__step-wrapper")

    this.currentStep = this.dataset.state
    this.allInputs = this.querySelectorAll(`.form__step-wrapper input`)

    // this.inputs = this.querySelectorAll(`.form__step-wrapper[data-step='${this.currentStep}'] input`)
    // this.inputNames = []
    // Array.from(this.inputs).forEach((i) => {if (!this.inputNames.includes(i.name)) this.inputNames.push(i.name)})
    // console.log(this.inputNames)

    this.setInputs(this.currentStep)

    this.back = this.querySelector("[data-form-back]")
    this.next = this.querySelector("[data-form-next]")
    this.submit = this.querySelector("[data-form-submit]")

    this.form = this.querySelector(".quiz__form")

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.closeQuiz.bind(this))

    this.allInputs.forEach((input) => {
      input.addEventListener('change', function(e){
        if(this.validateFormStep(this.inputs) == true) {
          this.next.removeAttribute('disabled')
        } else {
          this.next.setAttribute('disabled', 'true')
        }
      }.bind(this))
    })

    this.progressEl = this.querySelector('[data-quiz-progress]')
    this.progressFillEl = this.querySelector('[data-quiz-progress-fill]')
    this.progressTotalSteps = this.progressEl ? parseInt(this.progressEl.dataset.totalSteps, 10) : 0
    this.positionProgressLabels()
    this.updateProgressBar(this.currentStep)

    this.bindEvents();
  }

  positionProgressLabels() {
    if (!this.progressEl || !this.progressTotalSteps) return
    var labels = this.progressEl.querySelectorAll('.quiz__progress-label')
    labels.forEach(function(label, idx) {
      var stepNumber = idx + 1
      var percent = (stepNumber / this.progressTotalSteps) * 100
      label.style.left = percent + '%'
    }.bind(this))
  }

  updateProgressBar(step) {
    if (!this.progressFillEl || !this.progressTotalSteps) return
    var s = parseInt(step, 10) || 0
    var percent = Math.max(0, Math.min(100, (s / this.progressTotalSteps) * 100))
    this.progressFillEl.style.width = percent + '%'
  }

  bindEvents() {
    if (getCookie('affiliate_referrer') == 'redirect_sweatcoin1' && window.location.href.includes('pages/landing-page')) {
      this.open.forEach((button) => {
        button.addEventListener("click", function(e){
          e.preventDefault();
          console.log(window.location.pathname)
          window.location = '/products/at-home-whitening-kit-affiliate-ft'
        } )
      })
    } else {
      this.open.forEach((button) => {
        button.addEventListener("click", function(e){
          e.preventDefault();
          console.log(window.location.pathname)
          if(document.querySelector("body").classList.contains("Menu_Open")) {
            document.querySelector("menu-drawer").closeMenuDrawer()
          }
          document.querySelector('.sticky-footer__button')?.click()
        } )
      })
      this.back.addEventListener('click', this.changeFormStep.bind(this, -1))
      this.next.addEventListener('click', this.changeFormStep.bind(this, 1))
      this.close.addEventListener('click', this.closeQuiz.bind(this))
      this.submit.addEventListener('click', function(e){
        this.submitForm(e)
      }.bind(this))
    }
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (newValue !== oldValue && oldValue != null ) {
      this.querySelector(`.quiz__headline[data-step="${ oldValue }"`).classList.remove('active')
      this.querySelector(`.quiz__headline[data-step="${ newValue }"`).classList.add('active')

      this.querySelector(`.form__step-wrapper[data-step="${ oldValue }"`).classList.remove('active')
      this.querySelector(`.form__step-wrapper[data-step="${ newValue }"`).classList.add('active')

      this.updateProgressBar(newValue)

      var oldN = parseInt(oldValue, 10)
      var newN = parseInt(newValue, 10)
      if (!isNaN(oldN) && !isNaN(newN) && newN > oldN) {
        this.scrollQuizToTop()
      }

      if( newValue == 6 ){
        this.next.classList.toggle('hidden')
        this.submit.classList.remove('hidden')
        this.submit.setAttribute('disabled', 'true')
      }
      if ( newValue == 5 && oldValue == 6 ){
        this.next.classList.toggle('hidden')
        this.submit.classList.add('hidden')
      }
    }
  }

  scrollQuizToTop() {
    var quizEl = this.querySelector('.quiz')
    if (quizEl) {
      quizEl.scrollTop = 0
    }
    window.scrollTo(0, 0)
  }

  closeQuiz() {
    this.querySelector('.quiz').style.transitionDelay = '.2s'
    this.querySelector('.quiz').setAttribute('aria-hidden', 'true')
    document.querySelector('.page-transition__content').style.transform = 'translate(-50%, 50%)'
    setTimeout(() => {
      document.querySelector('.page-transition').classList.toggle('visible');
      document.querySelector('.sticky-footer__button').classList.toggle('hide')
      document.querySelector('.page-transition__content').style.removeProperty('transform')
      this.querySelector('.quiz').style.removeProperty('transition-delay')
    }, 900)
  }

  changeFormStep(x) {
    console.log('current step is ' + x)
    let currentState = this.dataset.state
    let newState = currentState
    if ( x === 1  && currentState < 6 ){
      newState = ++currentState
    } else if ( x === -1 && currentState > 1) {
      newState = --currentState
    }

    this.setAttribute('data-state', newState )

    this.setInputs(newState)
    if(this.validateFormStep(this.inputs) == true) {
      this.next.removeAttribute('disabled')
    } else {
      this.next.setAttribute('disabled', 'true')
    }
  }

  setInputs(step) {
    this.inputs = this.querySelectorAll(`.form__step-wrapper[data-step='${step}'] input`)
    this.inputNames = []
    Array.from(this.inputs).forEach((i) => {if (!this.inputNames.includes(i.name)) this.inputNames.push(i.name)})
  }

  validateFormStep(inputs) {
    let validationCheck = true
    for( const value of this.inputNames.values()){
      const i = this.querySelector(`[name='${value}']`)
      if( i.getAttribute('type') == 'checkbox' || i.getAttribute('type') == 'radio' ) {

        if(this.querySelector(`[name='${value}']:checked`)?.value == "" || this.querySelector(`[name='${value}']:checked`)?.value == undefined ){
          validationCheck = false
          break
        }
      } else {

        if(this.querySelector(`[name='${value}']`)?.value == "" || this.querySelector(`[name='${value}']`)?.value == undefined ){
          validationCheck = false
          break
        }
      }
    }
    return validationCheck
  }

  submitForm(e) {
    e.preventDefault();
    this.submit.classList.add("loading")
    // Check for email field
    // If we need more validation, we can add that. Currently email is the only required field
    if( this.querySelector('#ourformbutforklaviyo').value == ''){
      this.querySelector('#ourformbutforklaviyo').focus();
      this.querySelector('.form-error-message').classList.remove('hidden')
      this.submit.classList.remove("loading")
    } else {
      //prep data for submit
      let contactForm = new FormData(document.querySelector('#contact_form'))
      let klaviyoForm = document.querySelector("#email_signup")

      let sensitivity = document.querySelector('input[name="sensitivity"]:checked')?.value || 'medium'

      let formula_translate = {
        'mild' : 'strong',
        'medium': 'medium',
        'very': 'sensitive'
      }

      klaviyoForm.querySelector("#k_id_email").value = this.querySelector('#ourformbutforklaviyo').value
      klaviyoForm.querySelector("#k_id_firstname").value = this.querySelector('#first_name').value
      klaviyoForm.querySelector("#k_id_lastname").value = this.querySelector('#last_name').value
      klaviyoForm.querySelector("#klaviyo_form_sensitivity").value = formula_translate[sensitivity]

      let goals = ""
      this.querySelectorAll("[name='goals']:checked")?.forEach((goal) => {  goals == "" ? goals = goal.value : goals = goals + ", " + goal.value })

      klaviyoForm.querySelector("#klaviyo_form_goals").value = goals
      klaviyoForm.querySelector("#klaviyo_form_brush_times").value = this.querySelector("[name='brushtimes']:checked")?.value || ""
      klaviyoForm.querySelector("#klaviyo_form_cavities").value = this.querySelector("[name='cavities']:checked")?.value || ""
      klaviyoForm.querySelector("#klaviyo_form_plaque_concern").value = this.querySelector("[name='plaque_concern']:checked")?.value || ""

      let starting_shade = document.getElementById('quiz_shade_slider_start')?.value || ""
      let ending_shade = document.getElementById('quiz_shade_slider_end')?.value || ""
      klaviyoForm.querySelector("#klaviyo_form_shade").value = starting_shade

      klaviyoForm.querySelector("#klaviyo_form_stain").value = this.querySelector("[name='stain']:checked")?.value || ""
      klaviyoForm.querySelector("#klaviyo_form_previous_use").value = this.querySelector("[name='previous_use']:checked")?.value || ""

      let klaviyoFormData = new FormData(klaviyoForm)
      // for (var [key, value] of klaviyoFormData.entries()) { 
      //   console.log(key, value);
      // }

      // submit
      klaviyoForm.querySelector(".klaviyo_submit_button").click()

      // handle redirect
      console.log('strength is the following')
      console.log(formula_translate[sensitivity])

      document.cookie =  "strength=" + formula_translate[sensitivity] + "; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/;"
      document.cookie = "firstname=" + document.querySelector('#first_name').value + "; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/;"
      document.cookie = "lastname=" + document.querySelector('#last_name').value + "; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/;"
      document.cookie = "starting_shade=" + starting_shade + "; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/;"
      document.cookie = "ending_shade=" + ending_shade + "; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/;"

      setTimeout(function(){
        console.log(document.cookie)
  
        if (getCookie('affiliate_referrer') == 'ut' && getCookie('affiliate_referrer') != 'ut_direct') {
          window.location = '/products/at-home-whitening-kit-affiliate-ut'
          // window.location = '/products/at-home-whitening-kit'
          // console.log('not 2')
        } else if (getCookie('affiliate_referrer') == 'redirect_sweatcoin' || getCookie('affiliate_referrer') == 'cpgap_gen') {
          window.location = '/products/at-home-whitening-kit-affiliate-ft'
        } else if (getCookie('affiliate_referrer') == 'nift_6') {
          window.location = '/products/6-serving-of-whitening-gels-free-starter-kit'
        } else if (getCookie('affiliate_referrer') == 'nift_bundle') {
          window.location = '/products/starter-whitening-kit-6-treatments-free-pen'
        } else {
          window.location = '/products/at-home-whitening-kit'
        }
      }, 1000);

    }
  }
})